"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var http_1 = require("@angular/http");
var base_1 = require("@bhtp-client-api/base");
var rxjs_1 = require("rxjs");
var stateCacheKey = 'states';
var BhtpStateService = (function (_super) {
    __extends(BhtpStateService, _super);
    function BhtpStateService(http, cacheRepo) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.cacheRepo = cacheRepo;
        return _this;
    }
    BhtpStateService.prototype.getStates = function (countryIso2Code) {
        var _this = this;
        if (countryIso2Code === void 0) { countryIso2Code = 'US'; }
        var stateList = null;
        try {
            stateList = JSON.parse(this.cacheRepo.getValue(stateCacheKey));
        }
        catch (e) { }
        var result = rxjs_1.Observable.create(function (observer) {
            if (stateList == null) {
                var url = _this.getFullUrl("/StateByCountry/" + countryIso2Code);
                var options = _this.getStandardRequestOptions();
                _this.http.get(url, options)
                    .map(function (res) { return res.json(); })
                    .catch(_this.handleError)
                    .subscribe(function (response) {
                    observer.next(response);
                    _this.cacheRepo.storeValue(stateCacheKey, JSON.stringify(response));
                }, function (error) {
                    observer.error(error);
                }, function () {
                    observer.complete();
                });
            }
            else {
                observer.next(stateList);
                observer.complete();
            }
        });
        return result;
    };
    return BhtpStateService;
}(base_1.BhtpBaseService));
BhtpStateService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, Object])
], BhtpStateService);
exports.BhtpStateService = BhtpStateService;
//# sourceMappingURL=D:/a/1/s/eligibility/src/state.service.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/eligibility/src/state.service.js